import { listener, system } from './common';
import { moduleLoaded, pageLoaded } from './callback';
import { PDFium } from './pdfium-manager';

export let pdfReader = null;

export function initPDF(path, successful) {
  if (pdfManager.loadLibrary()) {
    console.log('pdfium init');
    pdfManager.init(path, successful);
  } else {
    console.error('load lib fail');
  }
}

export let pdfManager = {
  start: 1,
  current: null,
  total: null,
  tab: 0,

  width: 0,
  height: 0,

  pageSize: [],

  pageMode: 1,

  lock: false,

  THUMBNAIL_WIDTH: 150,

  thumbnails: {},

  scale: 1,

  loadLibrary: function () {
    if (!pageLoaded || !moduleLoaded) {
      return false;
    }

    PDFium.init();
    return true;
  },

  repPage: function (page) {
    let num = Math.abs(page % 2);
    if (this.start !== num) {
      page -= 1;
    }
    return page;
  },

  setStartPage(isOdd) {
    this.start = isOdd ? 1 : 0;
    this.current = null;
  },

  currentPage: function () {
    return this.current;
  },

  getCurrentPages: function () {
    let repPage = this.repPage(this.currentPage());
    let pairPage = this.getPairPage(repPage);
    return { leftPage: repPage, rightPage: pairPage };
  },

  init: function (url, successful) {
    var self = this;

    this.thumbnails = {};

    this.scale = 2;

    PDFium.loadFileFromURL(url)
      .then((fileByteArray) => {
        if (!fileByteArray) {
          throw new Error();
        }

        // setTimeout(() => {
        PDFium.processPDF(fileByteArray).then(() => {
          let [w, h] = PDFium.pageSize(0);
          self.pdfWidth = parseInt(w * self.scale);
          self.pdfHeight = parseInt(h * self.scale);
          self.total = PDFium.pageCount();
          self.pageSize = [];

          self.current = null;
          self.dispatch('init', {
            state: 'success',
            mode: this.pageMode,
            page: this.current,
            start: this.start,
            total: self.total,
            successful,
          });
        });
        // }, 300);
      })
      .catch((_) => console.log('pdf file error'));
  },

  setPage: function (pageNum, callback) {
    var self = this;

    if (
      null == pageNum ||
      undefined == pageNum ||
      isNaN(pageNum) ||
      this.start > pageNum
    ) {
      pageNum = this.start;
    }
    if (this.total && this.total < pageNum) {
      pageNum = this.total;
    }

    let tab = this.tab;
    let page = (pageNum = parseInt(pageNum));
    let curPage = this.current;

    this.current = pageNum;

    page = this.repPage(page);
    if (curPage) {
      curPage = this.repPage(curPage);
    }

    if (null == curPage || curPage !== page) {
      self
        .getPage(page, tab)
        .then((res) => {
          if (!this.pageSize[page])
            this.pageSize[page] = {
              width: res.pageWidth,
              height: res.pageHeight,
            };
          self.dispatch('load', res);
          return self.getPage(page + 1, tab);
        })
        .then((res) => {
          if (!this.pageSize[page + 1])
            this.pageSize[page + 1] = {
              width: res.pageWidth,
              height: res.pageHeight,
            };
          self.dispatch('load', res);
        })
        .finally(() => {
          self.dispatch('page', {
            page: pageNum,
            total: this.total,
            tab: tab,
            mode: this.pageMode,
          });
          callback && callback();
        });
    } else {
      self.dispatch('page', {
        page: pageNum,
        total: this.total,
        tab: tab,
        mode: this.pageMode,
      });
      callback && callback();
    }
  },

  toDataURL: function (w, h, data) {
    let canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;

    const x = canvas.getContext('2d');
    const i = x.createImageData(w, h);
    i.data.set(data);
    x.putImageData(i, 0, 0);

    return canvas.toDataURL();
  },

  getPage: function (pageNum, tab) {
    var self = this;
    if (pageNum > 0) {
      return new Promise(function (resolve) {
        let [w, h] = PDFium.pageSize(pageNum - 1, true);
        if (isNaN(w)) {
          w = self.pdfWidth;
        }
        if (isNaN(h)) {
          h = self.pdfHeight;
        }

        let width = parseInt(w * self.scale);
        let height = parseInt(h * self.scale);
        let [bitmap, html, text] = PDFium.getPageRender(
          pageNum - 1,
          width,
          height,
          1
        );
        resolve({
          page: pageNum,
          pageWidth: width,
          pageHeight: height,
          url: self.toDataURL(width, height, bitmap),
          text: html,
          search: text,
        });
      });
    } else {
      return new Promise(function (resolve) {
        resolve({
          page: pageNum,
          pageWidth: 0,
          pageHeight: 0,
          url: '',
          text: '',
          search: '',
        });
      });
    }
  },

  getThumbnail: function (pageNum) {
    let self = this;
    if (pageNum > 0) {
      return new Promise(function (resolve) {
        if (!self.thumbnails[pageNum]) {
          let [w, h] = PDFium.pageSize(pageNum - 1);
          if (isNaN(w)) {
            w = self.pdfWidth;
          }
          if (isNaN(h)) {
            h = self.pdfHeight;
          }
          h = parseInt((self.THUMBNAIL_WIDTH * h) / w);
          w = self.THUMBNAIL_WIDTH;
          let bitmap = PDFium.getPageBitmap(pageNum - 1, w, h);
          self.thumbnails[pageNum] = {
            page: pageNum,
            data: self.toDataURL(w, h, bitmap),
          };
        }
        resolve(self.thumbnails[pageNum]);
      });
    } else {
      return new Promise(function (resolve) {
        resolve({
          page: pageNum,
          data: '',
        });
      });
    }
  },

  searchText(keyword, start = 0, end) {
    return new Promise(function (resolve) {
      resolve(PDFium.searchText(keyword, start, end));
    });
  },

  prevPage: function () {
    if (null === this.current) {
      return;
    }
    let prePage;
    if (this.pageMode === PAGE_MODE.TWO_PAGE) {
      prePage = this.current - 2;
    } else {
      prePage = this.current - 1;
    }
    if (prePage < 1) {
      return this.setPage(1);
    }
    return this.setPage(prePage);
  },

  nextPage: function () {
    if (null === this.current) {
      return;
    }
    let nextPage;
    let page = this.current;
    if (this.pageMode === PAGE_MODE.TWO_PAGE) {
      nextPage = this.current + 2;
    } else {
      nextPage = this.current + 1;
    }
    if (nextPage > this.total) {
      return this.setPage(this.total);
    }
    return this.setPage(nextPage);
  },

  isStartPage: function () {
    if (this.pageMode === PAGE_MODE.TWO_PAGE) {
      return this.repPage(this.current) === this.start;
    }
    return this.current === 1;
  },

  isLastPage: function () {
    if (this.pageMode === PAGE_MODE.TWO_PAGE) {
      return this.repPage(this.current) + 1 >= this.total;
    }
    return this.current === this.total;
  },

  setPageMode: function (pageMode) {
    this.pageMode = pageMode;
  },

  getPairPage: function (page) {
    if (page === this.repPage(page)) {
      page += 1;
    } else {
      page -= 1;
    }

    return page;
  },
};

Object.assign(pdfManager, listener);
